import { assign } from 'xstate';
import { AppBarEvent } from '../../../events';
import { AppBarMachineContext } from '../../../machineContext';

export const name = 'setTargetClosed';

export const fn = assign<AppBarMachineContext, AppBarEvent>({
  target: () => 'closed',
});

export const action = {
  [name]: fn,
};

export default action;
